import React, { useCallback, useEffect, useState } from "react";
import CustomBreadcumbs from "../../../../component/atoms/custom-breadcumbs";
import TitlePages from "../../../../component/atoms/title-pages";
import { ArrowDownIcon, IconFilterReport } from "../../../../asset";
import { useNavigate } from "react-router-dom";
import { GROLOG_ORDER_URL } from "../../../../constant/apiConstant";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import TableReportOrderNoData from "./TableNoData";
import TableReportIsData from "./TableIsData";
import DrawerFilterReport from "./DrawerReport";
import { Button, Dropdown, Space } from "antd";
import PrimaryButton from "../../../../component/button/PrimaryButton";
import { setGlobalDA, setGlobalDAStatus, setGlobalDepotName, setGlobalOrderFrom, setGlobalOrderStatus, setGlobalTrip, setGlobalTripStatus } from "../../../../store/reducer/globalMultipleSearchSelect.reducer";
import ModalSuccessAdd from "../../../../component/modal/ModalSuccessAdd";
import ModalFailedDelete from "../../../../component/modal/ModalFailedDelete";

const MainReportDepot = () => {
  const { token, client_id, grolog_account_id, userId } = useSelector(
    (state) => state.auth
  );
  const dispatch = useDispatch();
  const [isDrawerOpened, setIsDrawerOpened] = useState(false);
  const [listData, setListData] = useState([]);
  const navigate = useNavigate();
  const [showDelete, setShowDelete] = useState(false);
  const [data, setData] = useState([]);
  const [searchRecommendation, setSearchRecommedation] = useState();
  const [listRecommendation, setListRecommendation] = useState([]);
  const [sorting, setSorting] = useState("");
  const [sortingBy, setSortingBy] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [initiate, setInitiate] = useState([]);
  const [filter, setFilter] = useState();
  const [loading, setLoading] = useState(false);
  const [isFilter, setIsfilter] = useState(false);
  const [titleFailed, setTitleFailed] = useState("");
  const [messageFailed, setMessageFailed] = useState("");
  const [failedModalOpen, setFailedModalOpen] = useState(false);
  const [messageFail, setMessageFail] = useState("");
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [filters, setFilters] = useState({
    "filter_selection" :{
        "depot": {
            "list_id": [-1],
            "exclude": false
        },
        "period_date": {
            "filter": "This Month",
            "from_date": "",
            "thru_date": ""
        },
        "delivery_associate_status":{
            "list": ["ALL"],
            "exclude": false
        },
        "delivery_associate":{
            "list_id": [-1],
            "exclude": false
        },
        "trip_status":{
            "list": ["ALL"],
            "exclude": false
        },
        "trip":{
            "list_id": [-1],
            "exclude": false
        },
        "order_from":{
            "list": ["ALL"],
            "exclude": false
        },
        "order_status":{
            "list": ["ALL"],
            "exclude": false
        }
    },
    "column_selection":{
        "country": false,
        "province": false,
        "district": false,
        "sub_district": false,
        "urban_village": false,
        "postal_code": false
    }
});
  const onClickFilter = useCallback(() => {
    setIsDrawerOpened(true);
  }, []);

  const onCloseFilter = useCallback(() => {
    setIsDrawerOpened(false);
  }, []);

  const doGet = async (endpoint, tkn, data, dispatch, refresh_token) => {
    const url = GROLOG_ORDER_URL + endpoint;
    const method = "POST";
    const headers = { Authorization: tkn };
    const request = { url, method, headers, data };
    return axios(request);
  };

  function replaceAll(jsonObj, searchValue, replaceValue) {
    for (let key in jsonObj) {
      if (typeof jsonObj[key] === 'object') {
        replaceAll(jsonObj[key], searchValue, replaceValue);
      } else if (Array.isArray(jsonObj[key])) {
        jsonObj[key] = jsonObj[key].map(value => value === searchValue ? replaceValue : value);
      }
    }
  }
  const fetchData = async (data, sort, pages, sortBy) => {
    setLoading(true);
    let newFilter = filters
    replaceAll(newFilter, "All", "ALL");
    console.log(newFilter);
    let datas = {
      page: pages ? pages : page,
      limit: limit,
      order: `${sortBy?sortBy:sortingBy} ${sort?sort:sorting}`,
      filter: filter
        ? "file_name lk " + filter
        : data
        ? "file_name lk " + data
        : "",
      connector: "",
      other: newFilter
    };
try{
    let res = await doGet(`/report/depot-report`, token, datas);
    // let init = await doGet(`/report/log-report/initiate`, token, datas);
    setListData(res?.data?.payload?.data);
    
    setLoading(false);
}catch(err){

}
  };

  // useEffect(() => {
  //   fetchData();
  //   // onChanged(dispatch, false);
  // }, [page, limit, filter]);

  // useEffect(()=>{
  //   fetchData()
  // },[filters])

  const doGetDownloadFile = async (endpoint, tkn, data) => {
    const url = GROLOG_ORDER_URL + endpoint;
    return axios({
            method: "POST",
            url: url,
            responseType: "arraybuffer",
            headers: { Authorization: tkn},
            data: data,
        });
  };
  const getFilenameFromBlob=(blob)=> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = function(event) {
            const uint8Array = new Uint8Array(event.target.result);
            let pdfText = "";
            for (let i = 0; i < uint8Array.length; i++) {
                pdfText += String.fromCharCode(uint8Array[i]);
            }
            const matches = pdfText.match(/\/Title \((.*?)\)/);
            if (matches && matches.length > 1) {
                const filename = matches[1];
                resolve(filename);
            } else {
                reject(new Error("Filename not found in PDF blob"));
            }
        };
        reader.onerror = function(event) {
            reject(new Error("Error reading PDF blob"));
        };
        reader.readAsArrayBuffer(blob);
    });
}
  const handleExport = async(reportType) =>{
    // let datas = {
    //   id: id,
    // };
    try{
    let res = await doGetDownloadFile(`/export/depot-report/${reportType}`, token, filters);
    // console.log("success",getFilenameFromBlob(res?.data));
//     const blob = new Blob([res?.data], { type: 'text/plain' });
// const filename = getFilenameFromBlob(blob);  
// .split("PH_")
      const url = window.URL.createObjectURL(new Blob([res?.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", res?.headers?.get("content-disposition")?.split("filename=")[1]);
      document.body.appendChild(link);
      setTimeout(link.click(), 2000);
      link.parentNode.removeChild(link);
      setTimeout(function () {
        window.URL.revokeObjectURL(link);
      }, 128);


    }catch(err){
      setTitleFailed("Data can't be downloaded")
      setMessageFailed(err?.response?.data?.payload?.message)
      setFailedModalOpen(true)
    }
  }

  const handleApply =()=>{
    fetchData();
  }

  const handleReset =()=>{
    setListData([])
    dispatch(setGlobalTrip([]));
    dispatch(setGlobalTripStatus([]));
    dispatch(setGlobalDA([]));
    dispatch(setGlobalDAStatus([]));
    dispatch(setGlobalDepotName([]));
    dispatch(setGlobalOrderFrom([]));
    dispatch(setGlobalOrderStatus([]));
    
  }

  const items = [
    {
      key: 'pdf',
      label: (
        <span className="font-roboto text-lg text-[#222222] w-[100%] h-full">
            PDF
          </span>
      ),
    },
    {
      key: 'csv',
      label: (
        <span className="font-roboto text-lg text-[#222222] w-[100%] h-full">
            CSV
          </span>
      ),
    },
  ]
  const onClick = ({ key }) => {
    handleExport(key)
  };
  const itemZero=[]
  return (
    <>
    

      <ModalFailedDelete
        show={failedModalOpen}
        action={() => setFailedModalOpen(false)}
        closable={false}
        width={414}
        // className={style.deleteModal}
        okText="Ok"
        title="Error"
        description={messageFail}
      />
      <CustomBreadcumbs
        jmlLevel={2}
        menuLevel1={"Report"}
        menuLevel2={"Report Depot"}
      />
      <TitlePages name={"Depot Report"} />
      <div className="flex justify-between mt-5">
        {/* <button onClick={()=>handleExport()} className="btn-export-disabled">Export</button> */}
        
        
      <Dropdown
        menu={!listData?.data?.length>0 ? {itemZero}:{
          items,
          onClick
        }}
        placement="bottom"
        // arrow
        disabled={!listData?.data?.length>0 }
        trigger={['click']}
      >
        <Button className={
        `w-[154px] h-[44px] ${ 
          !listData?.data?.length>0
            ? "bg-[#D7D7D7] text-[#ACACAC] cursor-not-allowed"
            : "bg-[#CF0000] text-white-100"
        }  text-xl rounded-md`}>
          {/* <Space> */}
            Export
          {/* <img src={ArrowDownIcon} alt="icon-filter-report" /></Space> */}
          </Button>
      </Dropdown>

      {/* <Dropdown
    menu={{
      items,
      onClick,
    }}
  >
    <a onClick={(e) => e.preventDefault()}>
      <Space>
        Hover me, Click menu item
        <DownOutlined />
      </Space>
    </a>
  </Dropdown> */}

      <button className="container-btn-filter-report" onClick={onClickFilter}>
          <span className="span-btn-filter-report">Filter</span>
          <img src={IconFilterReport} alt="icon-filter-report" />
        </button>
      </div>
      <div className="container-pages-table">
        {
          listData?.data?.length>0 ?
          <>
          <TableReportIsData data={listData}/>
          </>
          :
          <>
          <TableReportOrderNoData openFilter={onClickFilter} data={listData}/>
          </>
        }
      </div>
      <DrawerFilterReport onClose={onCloseFilter} open={isDrawerOpened} filters={filters} setFilters={setFilters} handleApply={handleApply} handleReset={handleReset}/>
    </>
  );
};

export default MainReportDepot;
